export const deviceList = {
    androidSmall: {
        device: 'Android small',
        width: 360,
        height: 800,
        scale: 1,
        hasLandscape: false,
    },
    androidLarge: {
        device: 'Android large',
        width: 412,
        height: 915,
        scale: 1,
        hasLandscape: false,
    },
    iosSmall: {
        device: 'iPhone small',
        width: 375,
        height: 667,
        scale: 0.95,
        hasLandscape: false,
    },
    iosLarge: {
        device: 'iPhone large',
        width: 414,
        height: 736,
        scale: 1,
        hasLandscape: false,
    },
    iPadPortrait: {
        device: 'iPad portrait',
        width: 810,
        height: 1010,
        scale: 0.5,
        hasLandscape: false,
    },
    iPadLandscape: {
        device: 'iPad landscape',
        width: 1010,
        height: 810,
        scale: 0.5,
        hasLandscape: true,
    },
    desktopSmall: {
        device: 'Desktop small',
        width: 1366,
        height: 768,
        scale: 0.55,
        hasLandscape: false,
    },
    desktopLarge: {
        device: 'Desktop large',
        width: 1920,
        height: 1080,
        scale: 0.5,
        hasLandscape: false,
    },
};
//# sourceMappingURL=device_list.js.map